import React, { useEffect, useState } from "react";
import BaseModal from "../common/HPBaseModal";
import HPInput from "../common/Input";
import { ModalProps } from "../../_constants/modal";
import { useAppDispatch } from "@/store";
import { modalDispatcher } from "@/store/slices/modal-slice";

interface ImageAltTextModalProps extends ModalProps {
  onConfirm: (altText: string) => Promise<void> | void;
  previewUrl?: string;
}

const ImageAltTextModal: React.FC<ImageAltTextModalProps> = ({
  onConfirm,
  cancelAction,
  previewUrl,
}) => {
  const dispatch = useAppDispatch();
  const { closeTopModal } = modalDispatcher(dispatch);
  const [altText, setAltText] = useState("");
  const [loading, setLoading] = useState(false);

  // The object URL is created by the caller for this modal's lifetime only —
  // revoke it whenever the modal goes away, regardless of how it closed.
  useEffect(() => {
    return () => {
      if (previewUrl) URL.revokeObjectURL(previewUrl);
    };
  }, [previewUrl]);

  const trimmedAltText = altText.trim();

  const handleConfirm = async () => {
    if (!trimmedAltText) return;
    setLoading(true);
    try {
      await onConfirm(trimmedAltText);
      closeTopModal();
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    cancelAction?.();
    closeTopModal();
  };

  return (
    <BaseModal
      title="Describe This Image"
      confirmButtonText="Upload"
      cancelButtonText="Cancel"
      loading={loading}
      confirmDisabled={!trimmedAltText}
      onConfirm={handleConfirm}
      onCancel={handleCancel}
      containerClassName="min-w-[540px]"
    >
      {previewUrl && (
        <div className="flex items-center justify-center bg-[#F9FAFB] border border-[#EAECF0] rounded-lg h-[220px] mb-3 overflow-hidden">
          <img
            src={previewUrl}
            alt=""
            className="max-w-full max-h-full object-contain"
          />
        </div>
      )}
      <HPInput
        label="Alt text*"
        placeholder="Describe this image for screen readers"
        value={altText}
        onChange={(event) => setAltText(event.target.value)}
        disabled={loading}
      />
    </BaseModal>
  );
};

export default ImageAltTextModal;
